'use client';

import React from 'react';
import { Metadata } from 'next';
import Layout from '@/components/layout/error-page';
import ErrorPage from '@/components/error-page';
import { DEFAULT_VIEWPORT } from '@/constants/meta-data';
import { sendError } from '@/api/tanzhi';

export const metadata: Metadata = {
  title: '抱歉，出错了 - 谈职',
  viewport: DEFAULT_VIEWPORT,
};

const Error = (props: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  const { error } = props;

  React.useEffect(() => {
    const { name, message, stack, digest } = error;

    if (name && message && stack) {
      if (name === 'ChunkLoadError') return;
      sendError({
        name,
        message: message + (digest || ''),
        stack,
        url: window.location.href,
      }).then();
    }
  }, [error]);

  return (
    <Layout needViewPort={true}>
      <ErrorPage errorCode={500} errorText="抱歉，出错了！" />
    </Layout>
  );
};

export default Error;
